import { createBootstrap } from "../../bootstrap";

export default createBootstrap("recipientsIncludingHidden", "accounts");
